<template>
    <div :id="adData.side" class="a-spot text-left" :class=[align] v-if="(adData && (adData.id || adData.hide !== true) )">
        <a :href="adData.url" @click="clickBanner(adData)" target="_blank" :title="adData.title">
            <img :src="adData.banner_url" :title="adData.title" :class="adClass" class="col-sm-12 p-0" :style="adStyle"/>
        </a>
        <div class="a-ph text-center font-style-italic" :style="{'width': adData.width}">Hirdetés</div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex'

    export default {
        name: 'Ad',
        props: ['data', 'align', 'hide', 'adClass'],
        data() {
            return {
                adData: this.data ? this.data : {},
                
            }
        },
        computed: {
            adStyle() {
                if(this.adData) {
                    return {
                        width: this.adData.width,
                        height: this.adData.height,
                    }
                }
            }
        },
        methods: {
            ...mapActions([
               'addBannerClick'
            ]),
            clickBanner(data) {
                this.addBannerClick({
                    id: data.id,
                    referer: window.location.href,
                })
            }
        },
        watch: {
            data: function(newVal) {
                this.adData = newVal;
            }
        }
    }
</script>

<style lang="scss">

.a-ph {
    font-style: italic;
    color: #a3a3a3;
    font-size: 12px;
}

    @media (max-width: 576px) {
        #ad {
            img {
                width: 100%;
            }
        }
    }

    @media (min-width: 578px) {
        .c729 {
            width: 729px;
            height: 90px;
        }

        .c250 {
            width: 250px;
            height: 250px;
        }

        .c370 {
            width: 370px;
            height: 370px;
        }
    }
</style>